"use client";

import { useFormFields } from "@payloadcms/ui";
import { TextFieldClient, TextFieldClientProps } from "payload";
import { useMemo } from "react";

const getBackgroundColor = (color?: string) => {
  switch (color) {
    case "dark":
      return "bg-[rgb(30, 28, 44)]";
    case "white":
      return "bg-white";
    case "orange":
      return "bg-orange-800";
    case "yellow":
      return "bg-yellow-500";
    case "blue":
      return "bg-blue-500";
    case "purple":
      return "bg-purple-500";
    default:
      return "bg-[rgb(30, 28, 44)]";
  }
};

const getTextColor = (color?: string) => {
  switch (color) {
    case "dark":
      return "text-black";
    case "white":
      return "text-white";
    case "orange":
      return "text-orange-500";
    case "yellow":
      return "text-yellow-500";
    case "blue":
      return "text-blue-500";
    case "purple":
      return "text-purple-500";
    default:
      return "text-white";
  }
};

export function QaBoxAdminBlock({ field, path, validate }: TextFieldClientProps) {
  const answerField = useFormFields(([fields]) => fields["answer"]);
  const answer = answerField?.value as string | undefined;

  const backgroundColorField = useFormFields(([fields]) => fields["backgroundColor"]);
  const backgroundColor = backgroundColorField?.value as string | undefined;

  const textColorField = useFormFields(([fields]) => fields["textColor"]);
  const textColor = textColorField?.value as string | undefined;

  const props: TextFieldClient = useMemo<TextFieldClient>(
    () => ({
      ...field,
      type: "text",
      admin: {
        ...field.admin,
        label: "Quick Answer",
        autoComplete: false,
        placeholder: "Your quick answer",
        rtl: false,
      },
    }),
    [field]
  );

  return (
    <>
      {answer && (
        <QaBoxBlock
          blockType="qa-box"
          answer={answer}
          backgroundColor={backgroundColor}
          textColor={textColor}
        />
      )}
    </>
  );
}

export type QaBoxBlockProps = {
  blockType: "qa-box";
  answer: string;
  backgroundColor?: string;
  textColor?: string;
};

type Props = QaBoxBlockProps & {
  className?: string;
};

export const QaBoxBlock: React.FC<Props> = ({ answer, backgroundColor, textColor }: Props) => {
  const backgroundClass = getBackgroundColor(backgroundColor);
  const textColorClass = getTextColor(textColor);

  return (
    <div
      className={`my-4 flex flex-col gap-1 rounded-sm border border-[rgb(66,66,66)] px-8 py-3 ${backgroundClass}`}
    >
      <h2 className={`text-2xl font-medium ${textColorClass}`}>Quick Answer</h2>
      <h3 className={`text-xl font-normal ${textColorClass}`}>{answer}</h3>
    </div>
  );
};
